module.exports = __webpack_public_path__ + "static/3-d6641ebe73e1131cbbd1d86388012a35.jpg";